import type { RuntimeStatus } from '../types'

function supportsFileSharing(): boolean {
  if (typeof navigator.share !== 'function' || typeof navigator.canShare !== 'function') return false
  try {
    const testFile = new File(['x'], 'x.png', { type: 'image/png' })
    return navigator.canShare({ files: [testFile] })
  } catch {
    return false
  }
}

export function getRuntimeStatus(): RuntimeStatus {
  return {
    online: navigator.onLine,
    modelsReady: false,
    crossOriginIsolated: window.crossOriginIsolated,
    webGpu: 'gpu' in navigator,
    shareFiles: supportsFileSharing(),
    clipboardRead: Boolean(navigator.clipboard?.read),
  }
}

export async function registerServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator) || !window.isSecureContext) return
  await navigator.serviceWorker.register(new URL('./sw.js', document.baseURI), { scope: './' })
}
